// Library Methods
import { createContext } from "react";

// Types
import {
  ExamReportDataType,
  ExamType,
  IndividualExternalExamType,
  ProgressionAnalysisType,
} from "src/services/exams/types";
import { PatientType } from "src/services/patients/types";

const ReportContext = createContext({
  patient: {} as PatientType | undefined,
  exam: {} as ExamType | undefined,
  externalExam: {} as IndividualExternalExamType | undefined,
  progressionAnalysis: {} as ProgressionAnalysisType | undefined,
  reportData: {} as ExamReportDataType,
  refetchExamComment: async (_: ExamType) => {},
  refetchProgressionAnalysisComment: async () => {},
  getReportInfoData: async () => {},
});

export { ReportContext };
